import TsaList, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/airport-security-wait-times';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default TsaList;
